export default "__VITE_ASSET__c5fa243e__"